import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";
import "../../../index.css";
import { ContentContainer } from "../SessionSection";
import ModalComponent from "../modal/modal.component";
import ImageComponent from "../image/image.component";
import { useEffect } from "react";
import "./blade-runner-styles.scss";
import bladeRunnerLogo from "../../../../src/assets/blade-runner/logo-blade-runner.webp";

import debrief from "../../../../src/assets/blade-runner/session01/debrief.webp";

import crimeLab from "../../../../src/assets/blade-runner/session01/rit-crime-lab.webp";
import wallaceCorp from "../../../../src/assets/blade-runner/session01/wallace-corporation.webp";
import lapdMainframe from "../../../../src/assets/blade-runner/session01/ladp-mainframe.webp";
import snakePit from "../../../../src/assets/blade-runner/session01/the-snake-pit.webp";

const pageHeader = {
  color: "white",
  backgroundColor: "black",
  opacity: "0.7",
  marginTop: "20px",
  padding: "15px",
};
const cardStyle = {
  textAlign: "left",
  fontFamily: "Special Elite",
  backgroundColor: "rgba(0, 0, 0, 0.7) ",
  color: "white",
  marginBottom: "15px",
};

const BRSession01 = () => {
  const [showModal, setShowModal] = React.useState("");
  const [modalData, setModalData] = React.useState({});
  const handleClick = (img, body, isLegend, caption) => {
    setModalData({
      body: body,
      image: img,
      isLegend: isLegend,
      caption: caption,
    });
    handleOpenModal();
  };
  const handleOpenModal = () => {
    setShowModal("show");
  };
  const handleCloseModal = () => {
    setShowModal("", "");
  };

  const section1Data = [
    {
      title: "Waking Up: The Debrief",
      text: (
        <div class="bladeRunnerFont bladeRunnerTitleText">
          <ImageComponent
            image={debrief}
            caption="Holden's Office"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Commanding Officer in Charge of the RDU is Police
Deputy Chief David Holden. Few envy his job. It’s
him behind the podiums at press conferences, and his
ass on the line when you screw up. Most of his day is
spent answering to a circle of vultures forever stalking
overhead: the Commissioner, the Governor, the District
Attorney, the UN, the Inspector General, the press,
even Wallace Corp and other special interests. He’s also
embroiled in constant internal conflicts with the other
LAPD divisions who envy the freedom and funding of
the RDU."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          Morning in the LAPD Tower begins with the slow churn of ceiling fans
          cutting through smoke-thick air in Deputy Chief Holden's office.
          Marion Carey sits at ease until he notices there's only one chair.
          Without a word, he offers it to Skinner, the senior detective. Skinner
          accepts with the same deadpan composure he uses on suspects—minimal
          movement, furrowed brow, giving away nothing.
          <br />
          <br />
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            "We have an urgent situation."
          </font>
          , rasps Deputy Chief Holden.
          <br />
          <br />
          The story comes hard and fast:
          <br />
          <br />
          <b>Deputy Chief Holden: </b>
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            "Last night, there was a shooting at the Snake Pit on Nightclub Row.
            Two Nexus-9 Blade Runners were there—Leah (LH3-7.93) and Sandor
            (SN9-1.48). Sandor's dead. Leah's missing. They'd been investigating
            possible Nexus-8 activity, but what sparked the violence is unknown.
            Witnesses mention human supremacists in the club."
          </font>
          <br />
          <br />
          Holden's tone darkens.{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            "If someone's out there killing or kidnapping Nexus-9s, we need to
            find them and stop them. Fast."
          </font>
          <br />
          <br />
          Wallace Corporation is breathing down the department's neck—Leah's
          disappearance could hit their bottom line. Quell, Wallace's PR
          manager, will expect cooperation. Holden gives them the usual carte
          blanche: the Crime Lab has Sandor's body, the Mainframe has files and
          Esper footage, and the Snake Pit is still an active crime scene.{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            "Get results,"
          </font>{" "}
          he growls.
          <br />
          <br />
          As they leave, Skinner talks to Marion,{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            "Have you been to Wallace Corp? I'd go, but I don't like that place.
            I like the Snake Pit—professionally and personally. You can handle
            Quell, you got good intuition for a robot brain."
          </font>{" "}
          Marion replies without hesitation,{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            "I'll talk to Quell. You check Sandor's body."
          </font>
          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },
    {
      title: "RIT Crime Lab",
      text: (
        <div class="bladeRunnerFont bladeRunnerTitleText">
          <ImageComponent
            image={crimeLab}
            caption="Crime Lab"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="RDU (Rep Detect Unit) Crime Lab is quietly ruled by Coco and his cat Biscuits."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          Skinner steps into the antiseptic chill of the Crime Lab. Coco glances
          up, offers a flat,{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            "Sorry you lost one of yours."
          </font>
          <br />
          <br />
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            "Part of the job,"
          </font>{" "}
          Skinner says, eyes narrowing.{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            "So, Coco—how's your coconut?"
          </font>{" "}
          It's a jab that bounces off Coco's wall of composure.
          <br />
          <br />
          Examining Sandor's body, Skinner's fingers find his mood ring, the
          familiar cool metal sparking his intuition. Large caliber slug to the
          chest—obvious enough—but the wound edges whisper of something darker:
          an LAPD-issue round. Both men agree the bullet at the scene needs
          recovering. Skinner leaves with a cigarette, tossing a parting,{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            "Stay loco, amigo."
          </font>{" "}
          Coco's slight eye-roll seals the small victory.
          <br />
          <br />
        </div>
      ),
    },
    {
      title: "Wallace Corporation",
      text: (
        <div class="bladeRunnerFont bladeRunnerTitleText">
          <ImageComponent
            image={wallaceCorp}
            caption="Wallace Corp"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Quell is VP of Public Relations at Wallace Corp. She is the main point of contact for the RDU. In may ways, she is the voice of Niander Wallace."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          As he approached the gleaming tower of Wallace Corporation, Marion's
          spinner is stopped before it even lands. Wallace security scans his
          badge, making him recite credentials like a perp. Inside, an
          androgynous escort leads him through echoing halls—postmodern
          brutality softened by ponds and trickling water.
          <br />
          <br />
          In a meeting room decorated like an expensive 20th-century smoking
          lounge, Quell arrives. High heels, short hair, eyes sharp as glass.
          She compliments his promptness, then stonewalls every question. Marion
          keeps it professional, but it's clear—Quell expects total access to
          the case without giving anything in return.{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            "Stay in touch, Detective Carey. Every step of the way."
          </font>
          <br />
          <br />
        </div>
      ),
    },
    {
      title: "LAPD Mainframe",
      text: (
        <div class="bladeRunnerFont bladeRunnerTitleText">
          <ImageComponent
            image={lapdMainframe}
            caption="Mainframe"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="The LAPD Mainframe is a vast archive of criminal intelligence containing detailed records on all past and current case
files. Dossiers on all recorded persons of interest and crimes
from past investigations. The Mainframe can be accessed
remotely via the player characters' KIA units, but spending a
Shift on-site gives an advantage to all TECH rolls."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          Skinner, glaring at the blinking cursor, works the LAPD mainframe. The
          machine complies, but the process gnaws at his patience—computers, to
          him, are like people who have no excuse to fail.
          <br />
          <br />
          He finds one key fact: Leah failed baseline testing twice before being
          recalibrated and returned to duty. He calls Marion, who cross-checks
          the failure dates against major crimes—nothing matches.
          <br />
          <br />
          <br />
        </div>
      ),
    },
    {
      title: "The Snake Pit",
      text: (
        <div class="bladeRunnerFont bladeRunnerTitleText">
          <ImageComponent
            image={snakePit}
            caption="Snake Pit"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="This variety club is infamous for its strong drinks, five-star
entertainment, and sordid history. Back in 2019, one of
their performers was retired on the street, later revealed as
a fugitive Nexus-6 conspirator behind the infamous 2019
Tyrell Corporation Murder Spree. Owner Taffey Lewis
spun the infamy into free publicity, turning his sultry club
into a sensation. The Pit still attracts the best stage performers around, mostly because half the audience works at
the nearby agencies."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          The Snake Pit is quiet in the daylight, but its reputation hums in the
          air. Marion flashes a holographic badge to the beat cops at the
          perimeter, Daniella and Tyrone. Skinner nods to them,{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            "I did your gig for years."
          </font>
          <br />
          <br />
          In the street crowd, a tall and pale, bald man meets Skinner's eyes
          and nods—a detail worth remembering in a city where most people look
          away from a Blade Runner.
          <br />
          <br />
          Inside, the music still blares and dance lights flash, an empty stage
          for Laffey, the owner, who barks about lost business before confirming
          Leah was at the bar with Sandor when things went bad.
          <br />
          <br />
          Skinner drifts to the dressing rooms, finding Iris—blonde wig,
          cigarette, Maddog 20-20 in hand. After sharing a slug of the booze,
          Iris trusts Skinner enough to share that she's seen Leah often,
          sometimes with the pale bald man—Styles—who "cares about us Nexus-9
          dancers." Skinner leaves her his card, personal number scrawled on the
          back.
          <br />
          <br />
          Examining the crime scene near the stage, Marion and Skinner find
          broken glass, overturned tables, and dried blood. Marion collects a
          blood sample. Behind a shattered mirror, they recover a misshapen
          slug. Remote LAPD mainframe AI object match query confirms it's a
          caseless .44; standard issue for LAPD Blade Runners.
          <br />
          <br />
          Marion asks, "Do we upload our findings on the slug?"
          <br />
          <br />
          Skinner shakes his head. "No, sir buddy. We don't know who to trust
          now."
          <br />
          <br />
        </div>
      ),
    },
  ];

  useEffect(() => {
    document.body.style.backgroundImage = `url(${require("../../../../src/assets/blade-runner/background-blade-runner-01.webp")})`;
    document.body.style.backgroundColor = "#000000";
    document.body.style.backgroundWidth = "100vw";
    document.body.backgroundHeight = "100vh";
    document.body.style.backgroundSize = "cover";
  }, []);

  return (
    <Container>
      <Row>
        <Col>
          <div
            style={{
              backgroundColor: "transparent",
              fontFamily: "Orbitron",
            }}
          >
            <div style={pageHeader}>
              <main role="main" className="inner cover text-center">
                <a name="pageTop" href="#pageTop">
                  <img
                    src={bladeRunnerLogo}
                    style={{
                      maxWidth: "400px",
                      backgroundColor: "white",
                      borderRadius: "10px",
                    }}
                    alt="Blade Runner campaign"
                  />
                </a>
              </main>

              <h1 className="cover-heading">WAKING UP</h1>
              <small>Blade Runner Session 01</small>

              {/* <p className="lead leadExtra">
                <BRSubNav />
              </p> */}
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card style={cardStyle}>
            {/* <img src={sectionDivider} alt="section divider" /> */}
            <Card.Body>
              <Card.Title
                id="cardTitle-blade-runner"
                className="cardTitle-blade-runner  "
              >
                <span
                  style={{
                    color: "white",
                    textAlign: "center",
                  }}
                >
                  One replicant Blade Runner dead, another missing. Wallace Corp
                  is on overwatch as Marion and Skinner work the case.
                </span>
                <br />
                <font
                  style={{
                    color: "#C21E56",
                    textAlign: "center",
                    fontStyle: "italic",
                  }}
                >
                  WARNING: SPOILERS for Electric Dreams case file.{" "}
                </font>
                <br />
                <small>
                  ⇐ Session 00:{" "}
                  <a href="./blade-runner-session-00">Training Day</a> --
                  Session 02: <a href="./blade-runner-session-02">The Tyger</a>{" "}
                  ⇒{" "}
                </small>
              </Card.Title>
              <div>
                <ContentContainer data={section1Data} />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default BRSession01;
